import { Card } from "antd";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import FormExtraction from "../../components/forms/FormExtraction/FormExtraction";
import { useExtractionDownload } from "../../features/api/crud/hooks/useExtractionDownload";
import styles from "./PageExtraction.module.scss";

const PageExtraction: React.FC = () => {
  const { downloadExtraction, isDownloading } = useExtractionDownload();

  return (
    <PageLayout>
      <div className={styles.root}>
        <h1>Extraction des Ã©vÃ©nements</h1>
        <Card className={styles.card}>
          <p className={styles.description}>
            SÃ©lectionnez une pÃ©riode et un format pour tÃ©lÃ©charger les
            Ã©vÃ©nements correspondants.
          </p>
          <FormExtraction
            onSubmit={downloadExtraction}
            isLoading={isDownloading}
          />
        </Card>
      </div>
    </PageLayout>
  );
};

export default PageExtraction;
